// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SMSUserSection from "./SMSUserSection/SMSUserSection.bs.js";
import * as UserProfileType from "../../app/entity/UserProfileType.bs.js";
import * as SendSMSSearchCmp from "./SendSMSSearchCmp.bs.js";
import * as ConfirmationModal from "../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";
import * as SendSmsDataMachine from "../../app/repo/SendSmsDataMachine.bs.js";
import * as SendSmsSidePanelCmp from "./SendSmsSidePanelCmp.bs.js";
import * as SendSMSAssetsManager from "../assets/SendSMSAssetsManager.bs.js";
import * as OpenTemplateManagerCmp from "./template-manager/OpenTemplateManagerCmp.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PreviouslySentMessagesListView from "./sms-list/PreviouslySentMessagesListView.bs.js";

SendSMSAssetsManager.importCss(undefined);

function UserAndMessageListView$DiscardConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var onCancelCb = Props.onCancelCb;
  var onConfirmCb = Props.onConfirmCb;
  return React.createElement(ConfirmationModal.make, {
              title: "Discard Changes",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, Discard",
              cancel_button_title: "No, Cancel",
              children: "You are about to close the sidebar. All the changes will be lost. Are you sure you wish to exit?"
            });
}

var DiscardConfirmationModal = {
  make: UserAndMessageListView$DiscardConfirmationModal
};

function UserAndMessageListView$ResendConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var onCancelCb = Props.onCancelCb;
  var onConfirmCb = Props.onConfirmCb;
  return React.createElement(ConfirmationModal.make, {
              title: "Re-Send Message",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, Submit",
              cancel_button_title: "No, Cancel",
              children: "You are about to re-send this SMS Message . Are you sure you wish to continue?"
            });
}

var ResendConfirmationModal = {
  make: UserAndMessageListView$ResendConfirmationModal
};

function UserAndMessageListView(Props) {
  var openSnackbar = Props.openSnackbar;
  var state = Props.state;
  var dispatch = Props.dispatch;
  var handle_search_click = Props.handle_search_click;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var dispatchPreviouslySentMessagesDetailsLive = function (data) {
    return Curry._1(dispatch, {
                TAG: /* PreviouslySentMessagesDetails */1,
                previouslySentMessagesDetails: {
                  TAG: /* Live */1,
                  _0: data
                }
              });
  };
  var dispatchUserSelected = function (user) {
    return Curry._1(dispatch, {
                TAG: /* SetSelectedUser */5,
                selectedUser: user
              });
  };
  var setShowSidePanel = function (showSidePanel) {
    return Curry._1(dispatch, {
                TAG: /* ShowSidePanel */6,
                showSidePanel: showSidePanel
              });
  };
  var fetchSmsList = function (phoneNumberOrOrderId) {
    if (phoneNumberOrOrderId !== "") {
      Curry._1(dispatch, {
            TAG: /* PreviouslySentMessagesDetails */1,
            previouslySentMessagesDetails: {
              TAG: /* Loading */0,
              _0: undefined
            }
          });
      return SendSmsDataMachine.fetchSmsList({
                  phone_number: phoneNumberOrOrderId,
                  limit: 20,
                  pagination_token: "0"
                }, country, (function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* PreviouslySentMessagesDetails */1,
                                previouslySentMessagesDetails: {
                                  TAG: /* Live */1,
                                  _0: data
                                }
                              });
                  }), (function (error) {
                    Curry._1(openSnackbar, {
                          TAG: /* Error */1,
                          _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                        });
                    return Curry._1(dispatch, {
                                TAG: /* PreviouslySentMessagesDetails */1,
                                previouslySentMessagesDetails: {
                                  TAG: /* Error */2,
                                  _0: error
                                }
                              });
                  }));
    }
    
  };
  var onSearchClick = function (phoneNumberOrOrderId) {
    Curry._1(handle_search_click, phoneNumberOrOrderId);
    return Curry._1(dispatch, {
                TAG: /* UserTypeSelection */2,
                userTypeSelection: /* All */0
              });
  };
  var userCardClick = function (index, phoneNumber) {
    Curry._1(dispatch, {
          TAG: /* SelectUser */4,
          selectUser: index
        });
    Curry._1(dispatch, {
          TAG: /* PhoneNumber */3,
          phoneNumber: phoneNumber
        });
    return fetchSmsList(phoneNumber);
  };
  var onBackdropClick = function (param) {
    return Curry._1(dispatch, {
                TAG: /* SetModalState */7,
                modal: /* DiscardModal */0,
                openModal: true
              });
  };
  var onConfirmationDiscardModalClick = function (param) {
    Curry._1(dispatch, {
          TAG: /* ShowSidePanel */6,
          showSidePanel: false
        });
    return Curry._1(dispatch, {
                TAG: /* SetModalState */7,
                modal: /* None */2,
                openModal: false
              });
  };
  var onCancelClick = function (param) {
    return Curry._1(dispatch, {
                TAG: /* SetModalState */7,
                modal: /* None */2,
                openModal: false
              });
  };
  var onConfirmationResendSMSClick = function (param) {
    var selectedUserDetails = state.resendSmsDetails;
    if (selectedUserDetails === undefined) {
      return Curry._1(dispatch, {
                  TAG: /* SetModalState */7,
                  modal: /* None */2,
                  openModal: false
                });
    }
    var order_id = selectedUserDetails.order_id;
    return SendSmsDataMachine.resendSmsMessage({
                phone_number: selectedUserDetails.phone_number,
                sms_id: selectedUserDetails.sms_id,
                order_id: order_id !== undefined ? order_id : undefined
              }, country, (function (data) {
                  var match = data.status_code;
                  if (match !== 200) {
                    return Curry._1(openSnackbar, {
                                TAG: /* Error */1,
                                _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                              });
                  } else {
                    Curry._1(openSnackbar, {
                          TAG: /* Success */0,
                          _0: "Request to re-send sms has been sent successfully"
                        });
                    Curry._1(dispatch, {
                          TAG: /* SetModalState */7,
                          modal: /* None */2,
                          openModal: false
                        });
                    return fetchSmsList(selectedUserDetails.phone_number);
                  }
                }), (function (error) {
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                            });
                }));
  };
  var onResendSmsClick = function ($$document) {
    Curry._1(dispatch, {
          TAG: /* SetResendSMSDetails */8,
          resendSmsDocument: $$document
        });
    return Curry._1(dispatch, {
                TAG: /* SetModalState */7,
                modal: /* ResendModal */1,
                openModal: true
              });
  };
  var onUserTypeSelection = function (tag) {
    Curry._1(dispatch, {
          TAG: /* UserTypeSelection */2,
          userTypeSelection: tag
        });
    Curry._1(dispatch, {
          TAG: /* SelectUser */4,
          selectUser: 0
        });
    var data = state.customerAndPartnerDetails;
    if (typeof data === "number") {
      return Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Error Getting partner details"
                });
    }
    if (data.TAG !== /* Live */1) {
      return Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Error Getting partner details"
                });
    }
    var data$1 = data._0;
    var filterCustomerAndPartnerDetails;
    switch (tag) {
      case /* All */0 :
          filterCustomerAndPartnerDetails = data$1;
          break;
      case /* Customer */1 :
          filterCustomerAndPartnerDetails = List.filter(function (user) {
                  var match = UserProfileType.fromString(user.profile);
                  if (match !== 1) {
                    return match < 4;
                  } else {
                    return false;
                  }
                })(data$1);
          break;
      case /* Partner */2 :
          filterCustomerAndPartnerDetails = List.filter(function (user) {
                  var match = UserProfileType.fromString(user.profile);
                  return match === 1;
                })(data$1);
          break;
      
    }
    var phoneNumber = List.nth(filterCustomerAndPartnerDetails, 0).primary_mobile_number;
    Curry._1(dispatch, {
          TAG: /* PhoneNumber */3,
          phoneNumber: phoneNumber
        });
    return fetchSmsList(phoneNumber);
  };
  var onOpenTemplateManagerClick = function (param) {
    return Curry._1(dispatch, {
                TAG: /* SetCurrentView */9,
                currentView: /* TemplateManagerView */2
              });
  };
  var match$1 = state.enableEditTemplate;
  var tmp;
  tmp = country.TAG === /* India */1 || !match$1 ? null : React.createElement(OpenTemplateManagerCmp.make, {
          onOpenTemplateManagerClick: onOpenTemplateManagerClick
        });
  var match$2 = state.customerAndPartnerDetails;
  var tmp$1;
  if (typeof match$2 === "number") {
    tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
  } else if (match$2.TAG === /* Live */1) {
    var match$3 = state.confirmationModal.modal;
    var tmp$2;
    switch (match$3) {
      case /* DiscardModal */0 :
          tmp$2 = React.createElement(UserAndMessageListView$DiscardConfirmationModal, {
                isOpen: state.confirmationModal.openModal,
                onCancelCb: onCancelClick,
                onConfirmCb: onConfirmationDiscardModalClick
              });
          break;
      case /* ResendModal */1 :
          tmp$2 = React.createElement(UserAndMessageListView$ResendConfirmationModal, {
                isOpen: state.confirmationModal.openModal,
                onCancelCb: onCancelClick,
                onConfirmCb: onConfirmationResendSMSClick
              });
          break;
      case /* None */2 :
          tmp$2 = null;
          break;
      
    }
    var match$4 = state.previouslySentMessagesDetails;
    var tmp$3;
    var exit = 0;
    if (typeof match$4 === "number") {
      tmp$3 = React.createElement(CircularLoader$Catalyst.make, {});
    } else {
      switch (match$4.TAG | 0) {
        case /* Loading */0 :
            tmp$3 = React.createElement(CircularLoader$Catalyst.make, {});
            break;
        case /* Live */1 :
        case /* Error */2 :
            exit = 1;
            break;
        
      }
    }
    if (exit === 1) {
      tmp$3 = React.createElement(PreviouslySentMessagesListView.make, {
            openSnackbar: openSnackbar,
            phoneNumber: state.phoneNumber,
            previouslySentMessagesDetails: state.previouslySentMessagesDetails,
            dispatchPreviouslySentMessagesDetailsLive: dispatchPreviouslySentMessagesDetailsLive,
            on_resend_click: onResendSmsClick
          });
    }
    tmp$1 = React.createElement("div", {
          className: "send-sms-list-section"
        }, React.createElement(SMSUserSection.make, {
              customerAndPartnerDetails: state.customerAndPartnerDetails,
              userTypeSelection: state.userTypeSelection,
              dispatchUserTypeSelection: onUserTypeSelection,
              selectUser: state.selectUser,
              userCardClick: userCardClick,
              dispatchUserSelected: dispatchUserSelected,
              setShowSidePanel: setShowSidePanel
            }), tmp$2, state.showSidePanel ? React.createElement(SendSmsSidePanelCmp.make, {
                selected_user: state.selectedUser,
                show_side_panel: state.showSidePanel,
                set_show_sidepanel: setShowSidePanel,
                openSnackbar: openSnackbar,
                fetchSmsList: fetchSmsList,
                on_back_drop_click: onBackdropClick
              }) : null, tmp$3);
  } else {
    tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
  }
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "sms-search-bar-top-section show-template-manager-btn"
                }, React.createElement(SendSMSSearchCmp.make, {
                      onSearchClick: onSearchClick
                    }), tmp), tmp$1);
}

var make = UserAndMessageListView;

export {
  DiscardConfirmationModal ,
  ResendConfirmationModal ,
  make ,
  
}
/*  Not a pure module */
